import React from 'react';
import { Link } from 'react-router-dom';
import OidcLogin from 'components/authentication/OidcLogin';
import LoginForm from 'components/authentication/LoginForm';
import { getConfig } from 'config/getConfig';

import AuthCardLayout from 'layouts/AuthCardLayout';
import paths from 'routes/paths';

const Login = () => {
  // OIDC가 활성화되어 있으면 OIDC 로그인 사용 (런타임 설정 우선)
  const { SSO_ENABLED } = getConfig();
  const isOidcEnabled = !!SSO_ENABLED;

  if (isOidcEnabled) {
    return (
      <AuthCardLayout
        leftSideContent={
          <p className="text-white">
            SafeDB에 오신 것을 환영합니다.<br />
            통합 인증을 통해 안전하게 로그인하세요.
          </p>
        }
      >
        <OidcLogin />

        {/* 기존 로그인으로 전환 옵션 */}
        <div className="text-center mt-3">
          <small className="text-muted">
            문제가 있으신가요?{' '}
            <Link
              to="/legacy/login"
              className="text-decoration-none"
            >
              기존 방식으로 로그인
            </Link>
          </small>
        </div>
      </AuthCardLayout>
    );
  }

  // OIDC가 비활성화되어 있으면 기존 로그인 사용
  return (
    <AuthCardLayout
      leftSideContent={
        <p className="text-white">

        </p>
      }
    >
      <LoginForm layout="card" hasLabel />
    </AuthCardLayout>
  );
};

export default Login;
